import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7299cce4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "anquanjianchadan-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "安全问题分析", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chart-1" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "chart-1",
    style: {"width":"100%","height":"100%"}
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "移动巡检分析", -1))
const _hoisted_5 = { class: "chart-2" }
const _hoisted_6 = {
  key: 0,
  id: "chart-2",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "安全问题趋势", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chart-3" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "chart-3",
    style: {"width":"100%","height":"100%"}
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (_ctx.flag)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, "暂无数据"))
    ]),
    _hoisted_8,
    _hoisted_9
  ]))
}